import React from 'react'
import { Formik } from 'formik'

import { Divider, Button, Form, Col, Row } from '_zari/core'

import { ValidationSchema } from '../_shared/validation'
import PlacaFormGroup from '../_shared/formGroups/placa'

import * as SocioService from 'services/socio.service'

const NuevaPlacaSubForm = ({ idSocio, refrescarTabla, refrescarListaPlacasHandler }) => {
  const formInitialValues = React.useMemo(
    () => ({
      placa: ''
    }),
    []
  )

  const submitHandler = async (data, { resetForm }) => {
    SocioService.nuevaPlacaxIdSocio(idSocio, data).then(() => {
      refrescarTabla()
      refrescarListaPlacasHandler()
      resetForm()
    })
  }

  return (
    <>
      <Divider title='Nueva Placa' />
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <PlacaFormGroup iError={errors.placa} iTouched={touched.placa} fIsSubmitting={isSubmitting} />
            <Row>
              <Col className='text-right'>
                <Button onClick={handleSubmit}>Crear</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default NuevaPlacaSubForm
